import React, { useEffect, useRef, useState } from 'react';
import {  Divider, Table, Popconfirm, Card, Tooltip, Switch,Input,Button,Tag,Row, Col, Drawer } from 'antd';
import {CheckCircleOutlined,CloseCircleOutlined,RightSquareOutlined,EyeOutlined,EditOutlined,SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import { Link, Redirect } from 'react-router-dom';
import {WorkerDto, WorkerRequest} from '@gtpl/shared-models/masters'
import {WorkerService} from '@gtpl/shared-services/masters'
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Excel } from 'antd-table-saveas-excel';
import moment from 'moment';
import PreProductionWorkersForm from './pre-production-workers';



/* eslint-disable-next-line */
export interface WorkersGridProps {
  
}

export const PreProductionWorkersView = (props: WorkersGridProps) => {

  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState(''); 
  const [searchedColumn, setSearchedColumn] = useState('');

  const [workerData, setWorkerData] = useState<WorkerDto[]>([]);
  const [selectedWorkerData, setSelectedWorkerData] = useState<WorkerDto>();
  const [drawerVisible, setDrawerVisible] = useState(false);

  
  const workerService = new WorkerService();

  useEffect(() => {
    getworkerData();
  }, []);

  /**
   * 
   */
  const getworkerData= () => {
    // const req = new UnitRequest(Number(localStorage.getItem('unit_id')))
    workerService.getAllworkerData().then(res => {
      if (res.intlCode) {
        setSelectedWorkerData(res.data);
        setWorkerData(res.data);

      } else {

            setWorkerData([]);
            AlertMessages.getErrorMessage(res.internalMessage);

        }
      
    }).catch(err => {
        setWorkerData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  /**
   * 
   * @param workstationData 
   */
  const deleteWorkers = (workerData:WorkerRequest) => {
    workerData.isActive=workerData.isActive?false:true;
    workerService.activateOrDeactivateworker(workerData).then(res => { console.log(res);
      if (res.status) {
        getworkerData();
        AlertMessages.getSuccessMessage('Success');
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }
   
    /**
     * 
     * @param workstationData 
     */
    const updateWorkers = (workerData: WorkerDto) => {
      console.log(workerData,"oppppppppp")
        workerService.updateWorker(workerData).then(res => { console.log(res);
        if (res.status) {
          AlertMessages.getSuccessMessage('Updated Successfully');
          getworkerData();
          setDrawerVisible(false);
        } else {
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      })
    }
   /**
   * used for column filter
   * @param dataIndex column data index
   */
  const getColumnSearchProps = (dataIndex:string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select());   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) :text
      )
      : null
     
  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

    //drawer related
    const closeDrawer=()=>{
      setDrawerVisible(false);
    }
  
    //TO open the form for updation
    const openFormWithData=(viewData: WorkerDto)=>{
      console.log('Opening drawer');
      setDrawerVisible(true);
      setSelectedWorkerData(viewData);
   
    }


  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },

    {
        title: 'Worker Id Number ',
        dataIndex: 'workerCode',
        // responsive: ['lg'],
        sorter: (a, b) => a.workerCode.localeCompare(b.workerCode),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('workerCode'),
        render: (text, record) => {
          return record.workerCode ? record.workerCode : '-'
        }
      },
    
    {
      title: 'Worker Name ',
      dataIndex: 'workerName',
      // responsive: ['lg'],
      sorter: (a, b) => a.workerName.localeCompare(b.workerName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('workerName'),
      render: (text, record) => {
        return record.workerName ? record.workerName : '-'
      }
    },
    {
      title: 'Aadhar Card Number',
      dataIndex: 'aadharCardNumber',
      // responsive: ['lg'],
      sorter: (a, b) => a.aadharCardNumber.localeCompare(b.aadharCardNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('aadharCardNumber'),
      render: (text, record) => {
        return record.aadharCardNumber ? record.aadharCardNumber : '-'
      }
    },
    {
        title: 'Date of Birth (as Per Aadhar)',
        dataIndex: 'dateOfBirth',
        // responsive: ['lg'],
        sorter: (a, b) => a.dateOfBirth.localeCompare(b.dateOfBirth),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('dateOfBirth'),
        render: (value, record: any, index) => {
            return record.dateOfBirth ? moment(record.dateOfBirth).format('DD-MM-YYYY') : "-"
          }
      },

      {
        title: 'Address',
        dataIndex: 'address',
        // responsive: ['lg'],
        sorter: (a, b) => a.address.localeCompare(b.address),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('address'),
        render: (text, record) => {
          return record.address ? record.address : '-'
        }
      },

    {
        title: 'Village From',
        dataIndex: 'villageFrom',
        // responsive: ['lg'],
        sorter: (a, b) => a.villageFrom.localeCompare(b.villageFrom),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('villageFrom'),
        render: (text, record) => {
          return record.villageFrom ? record.villageFrom : '-'
        }
      },

      
    {
        title: 'Contractor Name',
        dataIndex: 'contractorName',
        // responsive: ['lg'],
        sorter: (a, b) => a.contractorName.localeCompare(b.contractorName),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('contractorName'),
        render: (text, record) => {
          return record.contractorName ? record.contractorName : '-'
        }
      },

      {
        title: 'Date of Joining',
        dataIndex: 'dateOfJoining',
        // responsive: ['lg'],
        sorter: (a, b) => a.dateOfJoining.localeCompare(b.dateOfJoining),
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('dateOfJoining'),
        render: (value, record: any, index) => {
          return record.dateOfJoining ? moment(record.dateOfJoining).format('DD-MM-YYYY') : '-';
      }
      
      },
   
   
   
    {
      title: 'Status',
      dataIndex: 'isActive',
      render: (isActive, rowData) => (
        <>
          {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
          
        </>
      ),
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'InActive',
          value: false,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => 
      {
        // === is not work
        return record.isActive === value;
      },
      
    },
    {
      title:`Action`,
      dataIndex: 'action',
      width:"200px",
      render: (text, rowData) => (
        <span>         
            <EditOutlined  className={'editSamplTypeIcon'}  type="edit" 
              onClick={() => {
                if (rowData.isActive) {
                  openFormWithData(rowData);
                } else {
                  AlertMessages.getErrorMessage('You Cannot Edit Deactivated Worker');
                }
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />
          
          <Divider type="vertical" />
            <Popconfirm onConfirm={e =>{deleteWorkers(rowData);}}
            title={
              rowData.isActive
                ? 'Are you sure to Deactivate Worker  ?'
                :  'Are you sure to Activate Worker ?'
            }
          >
            <Switch  size="default"
                className={ rowData.isActive ? 'toggle-activated' : 'toggle-deactivated' }
                checkedChildren={<RightSquareOutlined type="check" />}
                unCheckedChildren={<RightSquareOutlined type="close" />}
                checked={rowData.isActive}
              />
          </Popconfirm>
        </span>
      )
    }
  ];
  const excelcolumns = [
    {
      title: 'Worker Id Number ',
      dataIndex: 'workerCode',
      // responsive: ['lg'],
    
      render: (text, record) => {
        return record.workerCode ? record.workerCode : '-'
      }
    },
  
  {
    title: 'Worker Name ',
    dataIndex: 'workerName',
    // responsive: ['lg'],
    
    render: (text, record) => {
      return record.workerName ? record.workerName : '-'
    }
  },
  {
    title: 'Aadhar Card Number',
    dataIndex: 'aadharCardNumber',
    // responsive: ['lg'],
   
    render: (text, record) => {
      return record.aadharCardNumber ? record.aadharCardNumber : '-'
    }
  },
  {
      title: 'Date of Birth (as Per Aadhar)',
      dataIndex: 'dateOfBirth',
      // responsive: ['lg'],
     
      render: (value, record: any, index) => {
          return record.dateOfBirth ? moment(record.dateOfBirth).format('DD-MM-YYYY') : "-"
        }
    },

    {
      title: 'Address',
      dataIndex: 'address',
      // responsive: ['lg'],
     
      render: (text, record) => {
        return record.address ? record.address : '-'
      }
    },

  {
      title: 'Village From',
      dataIndex: 'villageFrom',
     
      render: (text, record) => {
        return record.villageFrom ? record.villageFrom : '-'
      }
    },

    
  {
      title: 'Contractor Name',
      dataIndex: 'contractorName',
      // responsive: ['lg'],
     
      render: (text, record) => {
        return record.contractorName ? record.contractorName : '-'
      }
    },

    {
      title: 'Date of Joining',
      dataIndex: 'dateOfJoining',
     
      render: (value, record: any, index) => {
        return record.dateOfJoining ? moment(record.dateOfJoining).format('DD-MM-YYYY') : '-';
    }
    
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      render: (isActive, rowData) => (
        <>
          {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
          
        </>
      ),
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'InActive',
          value: false,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => 
      {
        // === is not work
        return record.isActive === value;
      },
      
    }
  ];
  /**
   * 
   * @param pagination 
   * @param filters 
   * @param sorter 
   * @param extra 
   */
  const onChange=(pagination, filters, sorter, extra)=> {
    console.log('params', pagination, filters, sorter, extra);
  }
  const OpenFormTocreateRecord = () => {
   console.log('redirect here');
  }
  const exportExcel = () => {
    const excel = new Excel();
    excel
      .addSheet('workers')
      .addColumns(excelcolumns)
      .addDataSource(workerData)
      .saveAs('workers.xlsx');
  }
  return (
 
    <Card title={<span style={{color:'white'}}>Workers</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={<><Link to='/worker'><Button className='panel_button'>Create </Button></Link></>}
    
    >
     <br></br>
     <Row gutter={40} >
      <Col>
          <Card title={'Total Workers: ' + workerData.length} style={{textAlign: 'left', width: 290, height: 41,backgroundColor:'#bfbfbf'}}></Card>
          </Col>
          <Col>
           <Card title={'Active: ' + workerData.filter(el => el.isActive).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#52c41a'}}></Card>
          </Col>
          <Col>
           <Card title={'In-Active: ' + workerData.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#f5222d'}}></Card>
          </Col>
          <Col>
          <Button icon={<DownloadOutlined />} onClick={() => { exportExcel(); } }>Get Excel</Button>
          </Col>
          </Row>
          <br></br>
          <Table
          rowKey={record => record.workerId}
          columns={columnsSkelton}
          dataSource={workerData}
          
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          onChange={onChange}
          bordered />
        <Drawer bodyStyle={{ paddingBottom: 80 }} title='Update' width={window.innerWidth > 768 ? '50%' : '85%'}
            onClose={closeDrawer} visible={drawerVisible} closable={true}>
            <Card headStyle={{ textAlign: 'center', fontWeight: 500, fontSize: 16 }} size='small'>
              <PreProductionWorkersForm key={Date.now()}
                workerData={selectedWorkerData}
                isUpdate={true}
                updateWorker={updateWorkers}
                closeForm={closeDrawer} />
            </Card>
          </Drawer>
     </Card>
     
  );
}

export default PreProductionWorkersView;
